module.exports = __webpack_public_path__ + "assets/images/curriculum-management.903cbe89b7b0e7f98ac7a281140830ad.svg";